module.exports = __webpack_public_path__ + "img/rightbicep-endo-mesomorph-female.d0c89571.svg";